export const globalAppInfo = {
    name: 'MessageStream',
    version: '1.0.0',
    description: 'This is a demo application',
    addressline1: 'Address Line 1',
    addressline2: '123 456',
    mobile1: '+911234567890',
    mobile2: '+911234567890',
    email1: 'infra@messageos.io',
    email2: 'infra@messageos.io',
    officestarttime: '9:00 AM',
    officeendtime: '6:00 PM',
};
